import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import profileADAMJNEID from './ADAM JUNAID.png';
import profileAMALIBRAHIM from './Amal ibrahim.png';
function Page20_b() {
const [ages, setAges] = useState({});

useEffect(() => {
const birthYears = {
ADAMJNEID:2008,
AMALIBRAHIM:1986,
};
const currentYear = new Date().getFullYear();
const calculatedAges = Object.keys(birthYears).reduce((acc, person) => {
 acc[person] = currentYear - birthYears[person];
 return acc;
}, {});
setAges(calculatedAges);
}, []);
return (
<section>
<Container fluid className="home-section"  >
<h1 id="about-section" className="project-heading" data-aos="flip-down">
 Let me introduce you<strong className="purple"> about myself</strong>
</h1>
<Container className="home-content">
 <Row className="justify-content-center align-items-center" style={{ minHeight: '2vh' }}>
<Col md={5} className="home-header" data-aos="fade-right">
<div className="bg-yellow-500 rounded-full absolute w-12 h-12 z-0 -left-4 -top-3 animate-pulse"></div>
<h1 style={{ paddingBottom: 5 }} className="heading">
Hi I'M <strong className="main-name">ADAM JNEID </strong>
</h1>
<h1 className="heading-name">
My age now: {ages.ADAMJNEID} years old
</h1>
<div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</Col>
<Col md={3} className="d-flex justify-content-center align-items-center" data-aos="fade-left">
<div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
 <div style={{ background: "#23BDEE" }} className="floating w-24 h-24 absolute rounded-lg z-0 -top-3 -left-3"></div>
<img
src={profileADAMJNEID}
alt="home pic"
className="img-fluid"
style={{
boxShadow: '0 4px 10px rgba(0, 128, 0, 0.6)',
 width: '200px',
height: '200px',
objectFit: 'cover',
 borderRadius: '10px'
}}
/>
 <div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</div>
</Col>
</Row>
</Container>
</Container>
<h1 id="story-section" className="project-heading" data-aos="flip-down">
This is my <strong className="purple">Story</strong>
</h1>
<Container fluid className="Story-section">
<Container>
<Row className="justify-content-center">
<Col md={4} className="text-left" data-aos="fade-right">
<p className="chinese-text">
我是亞當·朱奈德，目前就讀於滿納海學校。同時，我也在慈濟基金會極參與志工服務。
在2015年，我和家人居住在尤努斯·埃姆雷期間，我們得知蘇丹加濟有一所專門為敘利亞難民設立的學校。我的家人迅速為我在這所學校註冊。
當時，我對能夠就讀像滿納海學校這樣的學校感到非常高興。
最初開始在滿納海學校學習時，我發現這非常具有挑戰性。然而，隨著時間的推移和努力，我已經克服了那些挑戰，成長為一名成功和有成就的學生。
慈濟基金會的影響在我的生活中具有深遠的變革性。
慈濟基金會改變了我的生活。他們不僅幫助我就學，也支持了我的哥哥傑內德，他已經有4到5年沒有上學了。現在，他已經從大學畢業，成為一名工程師。
志工服務於慈濟基金會
在2018年，我了解了什麼是志工服務。那時候我還是個孩子，所以我經常跟著我的哥哥一起去做志工工作。
在人文真善美辦公室
因為我對攝影的興趣，我在志工余自成師兄的幫助下，參觀了慈濟基金會土耳其分部的媒體辦公室。多虧了他，我有機會作為攝影師與他們一起做志工服務。余先生還教我如何有效地拍照。今天，當我即將在20歲時從學校畢業，準備進入大學學習計算機工程時，我對學校深表感激，感謝他們始終如一的支持。
與慈濟滿納海學校團隊一起
每六個月，一組華語伴學計劃的志工們會來訪我們學校。作為一名志工，我通過翻譯協助他們，幫助他們與其他人交流。我的志工朋友們也加入我，提供翻譯支持，協助他們工作的進展。
</p>
</Col>
<Col md={4} className="text-right" data-aos="fade-left">
<p className="arabic-text">
أنا آدم جنيد، مسجل حاليًا في مدرسة مناهل. وفي الوقت نفسه، أشارك بشكل فعال كمتطوع داخل المؤسسة  
في عام 2015، أثناء إقامتي مع عائلتي في يونس إمري، تم إبلاغنا بوجود مدرسة تخدم اللاجئين السوريين في سلطان غازي. قامت عائلتي بتسجيلي على الفور في هذه المدرسة. في ذلك الوقت، كنت ممتلئًا بفرحة عميقة لاحتمال الالتحاق بمدرسة مثل مدرسة المناهل عندما بدأت الدراسة في المناهل لأول مرة، وجدت الأمر صعبًا للغاية. ومع ذلك، مع الوقت والجهد، تمكنت من التغلب على تلك التحديات وأصبحت طالب ناجح وبارع.  لقد كان تأثير Tzu Chi تحولًا عميقًا في حياتي.  لقد غيرت تسجي حياتي. لم يساعدوني في المدرسة فحسب؛ كما قاموا بدعم أخي الذي لم يذهب إلى المدرسة لمدة 4 إلى 5 سنوات. والآن تخرج من الجامعة كمهندس.   العمل التطوعي في تسجي في عام 2018، تعلمت معنى التطوع. في ذلك الوقت، كنت مجرد طفل، لذلك كنت أذهب مع أخي عندما كان يتطوع.  في المكتب الاعلامي   بسبب اهتمامي بالتصوير الفوتوغرافي، قمت بزيارة المكتب الإعلامي في Tzu Chi تركيا بمساعدة المتطوع السيد David Yu. وبفضله أتيحت لي الفرصة للتطوع كمصور معهم. علمني السيد ديفيد أيضًا كيفية التقاط الصور بفعالية.  مع فريق TC MENAHIL كل ستة أشهر، يقوم فريق من معلمي لغة الماندرين بزيارة مدرستنا. كمتطوع، أساعدهم من خلال الترجمة، ومساعدتهم على التواصل مع الآخرين. وينضم إلي زملائي الأصدقاء المتطوعين أيضًا في تقديم دعم الترجمة، مما يضمن التواصل الفعال أثناء زيارتهم
</p>
</Col>
</Row>
 </Container>
 </Container>
<Container fluid className="home-section"  >
<h1 id="about-section" className="project-heading" data-aos="flip-down">
 Let me introduce you<strong className="purple"> about myself</strong>
</h1>
<Container className="home-content">
 <Row className="justify-content-center align-items-center" style={{ minHeight: '2vh' }}>
<Col md={5} className="home-header" data-aos="fade-right">
<div className="bg-yellow-500 rounded-full absolute w-12 h-12 z-0 -left-4 -top-3 animate-pulse"></div>
<h1 style={{ paddingBottom: 5 }} className="heading">
Hi I'M <strong className="main-name">AMAL IBRAHIM </strong>
</h1>
<h1 className="heading-name">
My age now: {ages.AMALIBRAHIM} years old
</h1>
<div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</Col>
<Col md={3} className="d-flex justify-content-center align-items-center" data-aos="fade-left">
<div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
 <div style={{ background: "#23BDEE" }} className="floating w-24 h-24 absolute rounded-lg z-0 -top-3 -left-3"></div>
<img
src={profileAMALIBRAHIM}
alt="home pic"
className="img-fluid"
style={{
boxShadow: '0 4px 10px rgba(0, 128, 0, 0.6)',
 width: '200px',
height: '200px',
objectFit: 'cover',
 borderRadius: '10px'
}}
/>
 <div className="bg-yellow-500 w-40 h-40 floating absolute rounded-lg z-10 -bottom-3 -right-3"></div>
</div>
</Col>
</Row>
</Container>
</Container>
<h1 id="story-section" className="project-heading" data-aos="flip-down">
This is my <strong className="purple">Story</strong>
</h1>
<Container fluid className="Story-section">
<Container>
<Row className="justify-content-center">
<Col md={4} className="text-left" data-aos="fade-right">
<p className="chinese-text">
我來自敘利亞大馬士革，在美術學院學習，專攻視覺藝術（素描和繪畫）。
由於戰爭條件惡劣，我必須離開自己的國家到一個更安全的地方避難，所以我們別無選擇，只能選擇土耳其作為安全國家，我於2016年進入土耳其，住在伊斯坦堡蘇丹加濟。
我透過社群網站了解到滿納海學校，我很高興能與他們合作，但當我得知學校是由一個向世界各地的窮人和有需要的人伸出援手的慈善組織資助時，我的願望更加強烈。
是的，我很自豪自己是慈濟志工。
</p>
</Col>
<Col md={4} className="text-right" data-aos="fade-left">
<p className="arabic-text">
أنا المتطوعة أمل إبراهيم
من سوريا مدينة دمشق درست في كلية الفنون الجميلة تخصص الفنون البصرية (الرسم والتلوين) .
بسبب ظروف الحرب وقساوتها اضررت أن أترك بلدي وألتجأ ألى مكان أكثر أمان فما كان منا إلا أن نختار تركيا كبلد آمن.
دخلت تركيا في عام 2016 سكنت في اسطنبول السلطان غازي. تعرفت إلى مدرسة المناهل من خلال مواقع التواصل الاجتماعي كنت متحمسة جدا للعمل معهم ولكن زادت رغبتي عندما علمت أن مدرسة المناهل ممولة من جمعية خيرية تمد يد العون للفقراء والمحتاجين في كل مكان.
نعم أنا وبكل فخر متطوعة في جمعية تسوجي الخيرية

</p>
</Col>
</Row>
 </Container>
 </Container>
</section>
);
}
export default Page20_b;
